import Repository, { baseURL } from "./Repository"

import { createAsyncThunk } from "@reduxjs/toolkit"
import { toast } from "react-toastify"

export const smsApp = createAsyncThunk('sms',async(data)=>{
    return await Repository.post(`${baseURL}/SendAppSMS`,{
        Mobile:data.mobile
    })
    .then(res => {
        toast.success( res.data)
      }).catch(error =>{
        toast.error( error.response.data)
      
       
      })
})

export const numbers = createAsyncThunk('Stats',async(data)=>{
    return await Repository.post(`${baseURL}/Stats`)
    .then(res => {
        return res.data
      }).catch(error =>{
          return error.response.data
       
      })
})
export const slider = createAsyncThunk('Slider',async(data)=>{
    return await Repository.post(`${baseURL}/Slider`)
    .then(res => {
        return res.data
      }).catch(error =>{
          return error.response.data
       
      })
})